const SEARCH_HISTORY_KEY = 'globalSearchHistory';
const MAX_HISTORY_PER_CATEGORY = 10;

// 获取搜索历史
export const getSearchHistory = () => {
	try {
		const history = localStorage.getItem(SEARCH_HISTORY_KEY);
		return history ? JSON.parse(history) : { orders: [], customers: [], products: [] };
	} catch (error) {
		return { orders: [], customers: [], products: [] };
	}
};

// 保存搜索历史
export const saveSearchHistory = (category, item) => {
	try {
		const history = getSearchHistory();

		// 检查是否已存在（避免重复）
		const existingIndex = history[category].findIndex((h) => h.id === item.id);

		if (existingIndex >= 0) {
			// 如果已存在，移到最前面
			history[category].splice(existingIndex, 1);
		}

		// 添加到最前面
		history[category].unshift({
			...item,
			timestamp: Date.now(),
		});

		// 限制每个类别的历史记录数量
		history[category] = history[category].slice(0, MAX_HISTORY_PER_CATEGORY);

		localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
		return history;
	} catch (error) {
		return getSearchHistory();
	}
};

// 清除搜索历史
export const clearSearchHistory = (category = null) => {
	try {
		if (category) {
			const history = getSearchHistory();
			history[category] = [];
			localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
		} else {
			localStorage.removeItem(SEARCH_HISTORY_KEY);
		}
	} catch (error) {
		// 清除搜索历史失败，静默处理
	}
};

// 删除单个历史记录
export const removeSearchHistoryItem = (category, itemId) => {
	try {
		const history = getSearchHistory();
		history[category] = history[category].filter((item) => item.id !== itemId);
		localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
		return history;
	} catch (error) {
		return getSearchHistory();
	}
};

// 格式化时间显示（相对时间）
export const formatRelativeTime = (timestamp) => {
	if (!timestamp) return '';
	const now = Date.now();
	const diff = now - timestamp;
	const seconds = Math.floor(diff / 1000);
	const minutes = Math.floor(seconds / 60);
	const hours = Math.floor(minutes / 60);
	const days = Math.floor(hours / 24);
	const weeks = Math.floor(days / 7);
	const months = Math.floor(days / 30);

	if (months > 0) {
		return `${months}个月前`;
	} else if (weeks > 0) {
		return `${weeks}周前`;
	} else if (days > 0) {
		return `${days}天前`;
	} else if (hours > 0) {
		return `${hours}小时前`;
	} else if (minutes > 0) {
		return `${minutes}分钟前`;
	} else {
		return '刚刚';
	}
};

// 批量删除搜索历史
export const batchRemoveSearchHistory = (category, itemIds) => {
	try {
		const history = getSearchHistory();
		history[category] = history[category].filter((item) => !itemIds.includes(item.id));
		localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
		return history;
	} catch (error) {
		return getSearchHistory();
	}
};

// 获取搜索历史统计
export const getSearchHistoryStats = () => {
	try {
		const history = getSearchHistory();
		return {
			orders: history.orders?.length || 0,
			customers: history.customers?.length || 0,
			products: history.products?.length || 0,
			total: (history.orders?.length || 0) + (history.customers?.length || 0) + (history.products?.length || 0),
		};
	} catch (error) {
		return { orders: 0, customers: 0, products: 0, total: 0 };
	}
};
